import en from '../../profileContent.en';

const contact = {
    ...en.contact,
    metaTitle: 'Kontakt',
    metaDescription:
      'Skontaktuj się z Oracle Consults w sprawie konsultingu backendowego, przeglądów systemowych, porządkowania integracji i oprogramowania bogatego w workflowy.',
    eyebrow: 'Rozpocznij rozmowę',
    title: 'Powiedz, co się psuje, co jest wolne albo czemu trudno zaufać.',
    lead:
      'Najlepsza pierwsza wiadomość jest prosta: opisz, gdzie backend boli dzisiaj, co system powinien robić i jakiego typu współpracy szukasz.',
    fitTitle: 'Najlepiej dopasowane projekty',
    fitList: [
      'Backendy do magazynu, zamówień, rezerwacji i raportowania',
      'Porządkowanie integracji płatności, logistyki i API zewnętrznych',
      'Przegląd wąskich gardeł SQL i przepływu danych',
      'Przegląd architektury przed większą przebudową albo nowym impulsem produktowym'
    ],
    contactMethods: [
      { label: 'Email', value: 'oreste.twizeyimana99@gmail.com', href: 'mailto:oreste.twizeyimana99@gmail.com' },
      { label: 'Telefon', value: '+48 572 170 919', href: 'tel:+48572170919' },
      { label: 'GitHub', value: 'github.com/stere8', href: 'https://github.com/stere8/' },
      { label: 'LinkedIn', value: 'twizeyimana-o-2302a410a', href: 'https://www.linkedin.com/in/twizeyimana-o-2302a410a' }
    ],
    directContactTitle: 'Kontakt bezpośredni',
    discoveryTitle: 'Co dzieje się podczas rozmowy',
    discoveryIntro:
      'Jeśli łatwiej umówić rozmowę niż pisać długą wiadomość, rozmowa wstępna to najszybszy sposób, by zamienić mglisty problem backendowy w bardziej konkretny plan.',
    discoveryBullets: [
      'Identyfikujemy workflow, punkt nacisku w systemie i pilność problemu.',
      'Wyjaśniam, co sprawdziłbym najpierw i jaki typ współpracy ma największy sens.',
      'Wychodzisz z praktyczną jasnością, nawet jeśli kolejny krok jest niewielki.'
    ],
    scheduleButtonLabel: 'Umów rozmowę wstępną',
    closing:
      'Jeśli krótka rozmowa jest wygodniejsza niż długi opis, umów ją bezpośrednio, a przyjdę przygotowany do rozmowy o systemie, wąskich gardłach i najlepszym następnym kroku.'
  };

export default contact;
